import NotificationCard from '../Patterns/NotificationCard/NotificationCard.theme';
import SettingsCard from '../Patterns/SettingsCard/SettingsCard.theme';
import Alert from './Alert/Alert.theme';
import Accordion from './Accordion/Accordion.theme';
import Avatar from './Avatar/Avatar.theme';
import Badge from './Badge/Badge.theme';
import Breadcrumb from './Breadcrumb/Breadcrumb.theme';
import Button from './Button/Button.theme';
import Card from './Card/Card.theme';
import Checkbox from './Form/Checkbox/Checkbox.theme';
import ColorButton from './ColorButton/ColorButton.theme';
import Dialog from './Dialog/Dialog.theme';
import Divider from './Divider/Divider.theme';
import Drawer from './Drawer/Drawer.theme';
import EmptyState from './EmptyState/EmptyState.theme';
import Link from './Link/Link.theme';
import List from './List/List.theme';
import Menu from './Menu/Menu.theme';
import Radio from './Form/Radio/Radio.theme';
import Select from './Select/Select.theme';
import Input from './Form/Input/Input.theme';
import Dropdown from './Dropdown/Dropdown.theme';
import Tabs from './Tabs/Tabs.theme';
import Text from './Text/Text.theme';
import Table from './Table/Table.theme';
import Tooltip from './Tooltip/Tooltip.theme';
import CloseButton from './CloseButton/CloseButton.theme';
import Popover from './Popover/Popover.theme';
import Toggle from './Toggle/Toggle.theme';
import Textarea from './Form/Textarea/Textarea.theme';
import Form from './Form/Form.theme';
import DatePickerDay from './DatePicker/DatePickerDay.theme';
import NumberInput from './NumberInput/NumberInput.theme';
import Skeleton from './Skeleton/Skeleton.theme';
import ProgressBar from './ProgressBar/ProgressBar.theme';
import ProgressIndicator from './ProgressIndicator/ProgressIndicator.theme';
import Slider from './Slider/Slider.theme';
import Sidebar from './Sidebar/Sidebar.theme';
import SidebarItem from './Sidebar/SidebarItem.theme';
import SegmentedControl from './SegmentedControl/SegmentedControl.theme';
import Tag from './Tag/Tag.theme';
import Note from './Note/Note.theme';
import CodeSnippet from './CodeSnippet/CodeSnippet.theme';
import DefinitionTooltip from './DefinitionTooltip/DefinitionTooltip.theme';
import ExpandableCard from './ExpandableCard/ExpandableCard.theme';
import FileInput from './Form/FileInput/FileInput.theme';
import Filter from './Filter/Filter.theme';
import Toggletip from './Toggletip/Toggletip.theme';
import FilterSwitch from './Filter/FilterSwitch/FilterSwitch.theme';
import TagsInput from './Form/TagsInput/TagsInput.theme';
import DraggableCard from './DraggableCard/DraggableCard.theme';
import SelectableTag from './SelectableTag/SelectableTag.theme';
import DataWidget from './DataWidget/DataWidget.theme';

const components = {
  Accordion,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  ColorButton,
  DataWidget,
  Divider,
  Drawer,
  Dropdown,
  EmptyState,
  FilterSwitch,
  ...Form,
  Alert,
  CloseButton,
  CodeSnippet,
  DatePickerDay,
  DefinitionTooltip,
  DraggableCard,
  ExpandableCard,
  FileInput,
  Filter,
  Input,
  Link,
  List,
  Menu,
  Modal: Dialog,
  Note,
  NotificationCard,
  NumberInput,
  Popover,
  Progress: ProgressBar,
  ProgressIndicator,
  Radio,
  SegmentedControl,
  Select,
  SelectableTag,
  Sidebar,
  SidebarItem,
  Skeleton,
  Slider,
  Switch: Toggle,
  Table,
  Tabs,
  Tag,
  TagsInput,
  Text,
  Textarea,
  Toggletip,
  Tooltip,
  SettingsCard,
};

export default components;
